import React, { Component } from 'react';
import ReactEchartsCore from 'echarts-for-react/lib/core';
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')

const features = [
    "score",
    "floor area ratio",
    "building mix diversity",
    "peak load",
    "economics",
    "cop",
    "chiller utilization",
    "cooling demand",
    "vegetation coverage",
    "waterbody coverage",
    "ratio of street surface to building area",
    "cooling degree days",
]

// const distributions = [
//     { key: 'score', name: 'Score', min: 0, max: 100, numberOfSteps: 10 },
//     { key: 'far', name: 'Floor Area Ratio', min: Number.NaN, max: Number.NaN, numberOfSteps: Number.NaN },
//     { key: 'diversity', name: 'Building Mix Diversity', min: Number.NaN, max: Number.NaN, numberOfSteps: Number.NaN },
// ]

class Distributions extends Component {
    /**
     * @param {Number[]} data
     * @param {Number} min
     * @param {Number} max
     */
    getOption = (data, min, max, numberOfSteps, current) => {
        if (isNaN(min)) min = Math.min(...data);
        if (isNaN(max)) max = Math.max(...data);
        if (isNaN(numberOfSteps)) numberOfSteps = 10;
        let result;
        let step;
        if (max != min) {
            result = Array(numberOfSteps).fill(0).map((x, i) => [i, 0]);
            data.forEach((x, i) => {
                if (x < min) data[i] = min;
                if (x > max) data[i] = max;
            });
            step = (max - min) / numberOfSteps;
            data.forEach(x => result[Math.min(Math.floor((x - min) / step), numberOfSteps - 1)][1]++);
            result.forEach(x => x[0] = x[0] * step + min + step / 2);
            result.forEach(x => x[1] = x[1] / data.length);
        }
        else {
            step = 1;
            result = [[min - 1, 1], [min, 1], [max + 1, 1]];
        }
        return {
            tooltip: {
                trigger: 'axis',
                snap: true,
                showContent: false,
                axisPointer: {
                    type: 'cross',
                    // axis: 'x',
                    label: {
                        show: true,
                        precision: 2,
                        formatter: `{value}`,
                    }
                },
            },
            xAxis: {
                type: 'value',
                min: min != max ? min : min - 1,
                max: max != min ? max : max + 1,
                axisLabel: {
                    formatter: function (value, index) {
                        if (min == max) {
                            if (index == 1) return value.toFixed(1);
                            return;
                        }
                        if (max-min < 1) return value.toFixed(2);
                        else if (value < 100) return value.toFixed(1);
                        else return value.toExponential(1);
                    },
                    fontSize: 12,
                    rotate: min == max ? 0 : 45,
                },
                interval: min != max ? step : 1,
            },
            yAxis: {
                type: 'value',
                min: 0,
                max: 1,
            },
            series: [{
                data: result,
                smooth: true,
                type: 'line',
                symbol: 'none',
                lineStyle: {
                    color: "#1890ff"
                },
                areaStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: 'rgba(24,144,255,0.8)' // 0% 处的颜色
                        }, {
                            offset: 1, color: 'rgba(24,144,255,0)' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                    }
                }
            }, {
                data: [[current, 0], [current, 1]],
                type: 'line'
            }],
            grid: {
                top: "10px",
                left: "30px",
                right: "10px",
                bottom: "50px"
            }
        };
    }

    render() {
        if (JSON.stringify(this.props.distributions) != "{}") {
            const result = [];
            for (let key of features) {
                result.push({ key: key, data: this.props.distributions[key], min: Number.NaN, max: Number.NaN, numberOfSteps: Number.NaN })
            }
            return (
                <div className="Distributions">
                    <div className="SectionTitle" >Distributions</div>
                    <div className="SectionContent" >
                        {result.map(x => (
                            <div className="DistItem">
                                <div className="Name">{x.key}</div>
                                <ReactEchartsCore
                                    echarts={echarts}
                                    option={this.getOption(x.data, x.min, x.max, x.numberOfSteps, this.props.features[x.key])}
                                    style={{ width: '280px', height: '150px' }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="Distributions">
                    <div className="SectionTitle" >Distributions</div>
                    <div>Loading data...</div>
                </div>
            )
        }
    }
}

export default Distributions
